import styled, { css } from "styled-components";
import { HorizontalAlignment } from "../../types";
import { Device, breakpoint } from "../../device";

interface ButtonGroupProps {
    horizontalAlign?: HorizontalAlignment;
    buttonAlignment?: HorizontalAlignment;
}

const buttonAlignLeft = (horizontalAlign?: HorizontalAlignment) =>
    horizontalAlign === "left"
        ? css`
              display: flex;
              justify-content: left;
              flex-wrap: nowrap;

              ${Device.mobileMax} {
                  flex-direction: column;
                  width: 100%;
              }

              ${Device.tablet} {
                  flex-wrap: wrap;
              }

              ${Device.laptop} {
                  flex-wrap: wrap;
              }

              ${Device.desktop} {
                  flex-wrap: nowrap;
              }

              > a,
              > button {
                  margin-left: 0;
                  margin-right: 1rem;

                  &:last-child {
                      margin-right: 0rem;
                  }

                  ${Device.mobileMax} {
                      margin-right: 0.5rem;
                  }
              }
          `
        : null;

const buttonAlignCenter = (horizontalAlign?: HorizontalAlignment) =>
    horizontalAlign === "center"
        ? css`
              text-align: center;
              display: flex;
              justify-content: center;

              > a,
              > button {
                  margin-left: 0.5rem;
                  margin-right: 0.5rem;
                  ${Device.mobileMax} {
                      margin-left: 0.25rem;
                      margin-right: 0.25rem;
                  }
              }
          `
        : null;

const buttonAlignRight = (horizontalAlign?: HorizontalAlignment) =>
    horizontalAlign === "right"
        ? css`
              display: flex;
              justify-content: right;
              > a,
              > button {
                  margin-right: 0;
                  margin-left: 1rem;
                  &:first-child {
                      margin-left: 0rem;
                  }
                  ${Device.mobileMax} {
                      margin-right: 0.25rem;
                  }
              }
          `
        : null;

const ButtonGroup = styled.div<ButtonGroupProps>`
    ${(props) => buttonAlignLeft(props.horizontalAlign)}
    ${(props) => buttonAlignCenter(props.horizontalAlign)}
    ${(props) => buttonAlignRight(props.horizontalAlign)}
`;

ButtonGroup.defaultProps = {
    horizontalAlign: "left",
    buttonAlignment: "left",
};

export default ButtonGroup;
